import React from 'react';

const ThumbsDownIcon = ({ color="#0AB", fill, ...props}) => (
<svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={16} 
    height={16}
    viewBox="0 0 24 24" 
    fill={ fill ? color :"none"} 
    stroke={color} 
    stroke-width="2" 
    stroke-linecap="round" 
    stroke-linejoin="round" 
    class="lucide lucide-thumbs-down-icon lucide-thumbs-down"
>
    <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"/>
    <path d="M17 14V2"/>
</svg>
);

export default ThumbsDownIcon;